// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "assets/css/" + chunkId + "." + {"343":"8d9efcb3","590":"91127c13"}[chunkId] + ".css";
};